module.exports = __webpack_public_path__ + "img/20210827115538357b72.c5b6ab30.png";